<template>
  <a-layout class="back-layout">
    <a-layout-header class="back-header">
      <div>
        <div class="m-site-name">
          <div class="m-site-icon">
            <a-icon
              class="trigger"
              :type="collapsed ? 'menu-unfold' : 'menu-fold'"
              @click="() => (collapsed = !collapsed)"
            />
          </div>
          <span class="line" />
          <span class="m-site-title">
            数创运营交付平台
          </span>
        </div>
      </div>
      <div class="head-opts">
        <head-user
          :user-info="userInfo"
          @logout="logout"
        />
      </div>
    </a-layout-header>
    <a-layout>
      <a-layout-sider
        v-model="collapsed"
        theme="light"
        :trigger="null"
        collapsible
        :collapsed-width="60"
      >
        <a-menu
          mode="inline"
          :selected-keys="selectedKeys"
          :default-open-keys="openKeys"
          @click="onMenuClick"
        >
          <template v-for="item in menus">
            <template v-if="item.hasPermissions">
              <a-menu-item
                v-if="!item.children"
                :key="item.key"
              >
                <a-icon
                  v-if="item.icon"
                  :type="item.icon"
                />
                <span>{{ item.title }}</span>
              </a-menu-item>
              <sub-menu
                v-else
                :key="item.key"
                :menu-info="item"
                :menu-list="menuList"
              />
            </template>
          </template>
        </a-menu>
      </a-layout-sider>
      <a-layout>
        <a-layout-content class="back-layout-content">
          <router-view />
        </a-layout-content>
        <a-layout-footer class="back-layout-footer">
          copyright ©{{ moment(new Date()).format('YYYY') }} 网易出品
        </a-layout-footer>
      </a-layout>
    </a-layout>
  </a-layout>
</template>

<script>
import moment from 'moment'
import { Menu } from 'ant-design-vue'
import HeadUser from '@/components/common/HeadUser.vue'
import { hasPermissions } from '@/permissions/util'

import baseSvg from '@/assets/icons/menu/base.svg'
import incomeSvg from '@/assets/icons/menu/income.svg'
import resourceSvg from '@/assets/icons/menu/resource.svg'

const menuList = {
  base: baseSvg,
  resource: resourceSvg,
  income: incomeSvg
}
// v-if="item.hasPermissions"
const SubMenu = {
  template: `
    <a-sub-menu :key="menuInfo.key" v-bind="$props" v-on="$listeners">
      <span slot="title">
        <a-icon v-if="menuInfo.icon" :type="menuInfo.icon" />
        <span>{{ menuInfo.title }}</span>
      </span>
      <template v-for="item in menuInfo.children">
        <template v-if="item.hasPermissions">
          <a-menu-item v-if="!item.children" :key="item.key">
            <span>{{ item.title }}</span>
          </a-menu-item>
          <sub-menu v-else :key="item.key" :menu-info="item" />
        </template>
      </template>
    </a-sub-menu>
  `,
  name: 'SubMenu',
  isSubMenu: true,
  props: {
    ...Menu.SubMenu.props,
    menuInfo: {
      type: Object,
      default: () => ({})
    },
    menuList: {
      type: Object
    }
  }
}

export default {
  components: {
    HeadUser,
    SubMenu
  },
  data () {
    return {
      collapsed: false,
      openKeys: [],
      selectedKeys: [],
      unreadTotal: 0,
      menuList
    }
  },
  computed: {
    apis () {
      return this.$store.state.apis
    },
    userInfo () {
      return this.$store.state.userInfo
    },
    menus () {
      this.menuConfig.forEach(menu => {
        menu.hasPermissions = hasPermissions(this.apis, menu.apis, menu.someApis)
        if (menu.children) {
          menu.children.forEach(item => {
            item.hasPermissions = hasPermissions(this.apis, item.apis, item.someApis)
          })
        }
      })
      return this.menuConfig
    },
    menuConfig () {
      return [
        {
          icon: 'appstore',
          key: '/resource/setting',
          title: '资源管理',
          children: [
            {
              key: '/resource/setting',
              title: '资源配置'
            },
            {
              key: '/resource/detail',
              title: '资源发放详情'
            },
            {
              key: '/resource/dispenseflow',
              title: '发放与流水'
            }
          ]
        },
        {
          icon: 'dollar',
          key: '/income/voucherIncome',
          title: '收入管理',
          children: [
            {
              key: '/income/voucherIncome',
              title: '券类收入'
            },
            {
              key: '/income/shareIncome',
              title: '均摊收入'
            },
            {
              key: '/income/summary',
              title: '收入汇总'
            }
          ]
        },
        {
          icon: 'dollar',
          key: '/statistics/empowerAnalysis',
          title: '数据分析',
          children: [
            {
              key: '/statistics/empowerAnalysis',
              title: '赋能分析',
              apis: ['@productLine/Query_ProductLine']
            },
            {
              key: '/statistics/incomeAnalysis',
              title: '收入分析',
              apis: ['@productLine/Query_ProductLine']
            }
          ],
          apis: ['@productLine/Query_ProductLine']
        },
        {
          icon: 'desktop',
          key: '/baseinfo/base',
          title: '基础信息管理',
          children: [
            {
              key: '/baseinfo/base',
              title: '基地管理'
            },
            {
              key: '/baseinfo/product',
              title: '产品管理',
              apis: ['@productManage/Query_Products']
            },
            {
              key: '/baseinfo/user',
              title: '用户管理',
              apis: ['@userManage/Query_Users']
            }
          ]
        }
      ]
    }
  },
  watch: {
    $route (to) {
      this.updateMenu(to.path)
    }
  },
  beforeCreate () {
    // 路由拦截处已调用
    this.$store.dispatch('getUserInfo')
  },
  created () {
    this.updateMenu(this.$route.path)
  },
  methods: {
    moment,
    onMenuClick ({ key }) {
      if (this.$route.path !== key) {
        this.$router.push(`/admin${key}`)
      }
    },
    updateMenu (path) {
      const config = this.menuConfig

      // 遍历菜单配置项
      const travel = (list = [], path) => {
        if (!list.length) {
          return []
        }

        let openKeys = []
        let selectedKey = ''

        for (let i = 0; i < list.length; i++) {
          const { key, children } = list[i]
          const isSubMenu = children && children.length

          if (isSubMenu) {
            const [o, s] = travel(children, path)
            if (s) {
              openKeys = [key].concat(o)
              selectedKey = s
              break
            }
          } else if ((`/admin${key}` === path) || (path.indexOf(key) === 0)) {
            // 当路由完全匹配 or 匹配上前缀即认为当前页面在该菜单项下
            selectedKey = key
            break
          }
        }

        return [openKeys, selectedKey]
      }

      const [openKeys = [], selectedKey] = travel(config, path)

      this.selectedKeys = selectedKey ? [selectedKey] : []
      this.openKeys = Array.from(new Set([].concat(this.openKeys, openKeys)))
    },
    logout () {
      this.$store.dispatch('logout')
    }
  }
}
</script>

<style lang="less">
@import '@/assets/less/back-layout.less';

.back-layout {
  &-content {
    min-height: calc(100vh - 121px) !important;
  }

  .ant-menu-inline {
    border-color: #fff;
  }

  .ant-menu-vertical {
    border-color: #fff;
  }
}
</style>
<style lang="less">
.m-site-name {
  display: flex;
}

.site-name {
  color: #fff;
  margin-left: 20px;
}

.m-site-icon {
  width: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.m-site-title {
  color: #fff;
  font-size: 16px;
  padding: 0 16px;
  user-select: none;
}

.ant-layout {
  min-height: 100%;
  background: var(--bg-primary);

  .g-header.u-header {
    padding: 0 45px 0 0;
    box-shadow: 0 2px 14px 0 rgba(0, 0, 0, 0.05);
  }

  .ant-menu-inline-collapsed {
    width: 60px;
  }

  .trigger {
    font-size: 18px;
    line-height: 52px;
    cursor: pointer;
    transition: color 0.3s;
    vertical-align: middle;
    display: inline-block;
    color: #fff;
  }

  .back-header {
    background: #2d3b5f;
    padding: 0;
    z-index: 1;
    display: flex;
    justify-content: space-between;
    padding-right: 40px;
    box-shadow: 0 2px 14px rgba(0, 0, 0, 0.05);
  }

  .ant-layout-sider {
    background: #fff;
  }

  .ant-layout-header {
    height: 52px;
    line-height: 52px;
  }

  .line {
    width: 1px;
    height: 52px;
    background: #fff;
    opacity: 0.2;
    position: absolute;
    top: 0;
    left: 59px;
  }

  .logo {
    height: 32px;
    // background: rgba(255, 255, 255, 0.2);
    color: #fff;
    line-height: 32px;
    margin: 10px 16px;
    display: inline-block;

    .local-icon {
      font-size: 32px;
      width: 4em;

      &.z-small {
        width: 1em;
        margin-left: 0.2em;
      }
    }
  }

  .ant-menu {
    user-select: none;
  }

  .ant-layout-footer {
    background-color: transparent;
    color: rgba(16, 32, 72, 0.25);
  }
}

.head-opts {
  display: flex;
  align-items: center;
}

.m-message {
  margin-right: 20px;
  vertical-align: middle;

  a {
    margin-right: 5px;
  }

  .u-bell {
    font-size: 17px;
    color: #333;

    &:hover {
      color: #40a9ff;
    }

    &:active {
      color: #096dd9;
    }
  }
}

.my-anction {
  width: 20px;
  height: 20px;
}

.ant-layout-sider-children {
  .ant-menu-inline-collapsed > .ant-menu-item,
  .ant-menu-inline-collapsed > .ant-menu-submenu > .ant-menu-submenu-title,
  .ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-item,
  .ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-submenu > .ant-menu-submenu-title {
    padding: 0 22px !important;
  }
}
</style>
